import React from 'react'
import serviceapi from './ServiceApi'
import ServiceApi from "./ServiceApi"
import "./index.css"
import Navbar from "./Navbar";
export default function Services() {
  return (
    <>
    <Navbar/>
    <section>
    <div className="container ">
    <div className="row p-5 align-items-center flex-wrap justify-content-around">
    <h1 className="main-heading text-center">How to send money?</h1>
 
    {serviceapi.map(function(curEl){
        return(
            <>
            <div style={{"width":"25%"}} key={curEl.id} className=" service-card flex-wrap m-4 text-center work-container sub-div">
            <i
              style={{ "margin-bottom": "1rem", "font-size": "4rem" }}
              class={curEl.logo}
            ></i>
            <h2 className="sub-heading">{curEl.title}</h2>
            <p className="main-hero-para w-100">{curEl.info}</p>
          </div>
            </>
        )
    })}
    
    </div>
    </div>
    </section>
    </>
  )
}
